import { DateTime } from 'luxon'

import { type AgeAssuranceHistory, YotiMethod } from '@/client/services/ageAssurance/types'

export type AgeAssuranceStep =
  | 'yoti'
  // Choose between Yoti IDV or VideoAsk
  | 'choice'
  | 'videoask'

export default function getNextAgeAssuranceStep(
  history: AgeAssuranceHistory
): AgeAssuranceStep | null {
  const eligibleHistory = history.filter(session => session.nullifiedAt == null)

  if (eligibleHistory.length === 0) {
    return 'yoti'
  }

  const latestSession =
    eligibleHistory
      .sort((a, b) => DateTime.fromISO(b.startedAt).diff(DateTime.fromISO(a.startedAt)).toMillis())
      .at(0) ?? null

  if (
    // 1. pending
    latestSession?.status === 'pending' ||
    // 2. or completed - success
    (latestSession?.status === 'completed' && latestSession.outcome === 'success') ||
    // 3. or videoask - completed - fail
    (latestSession?.config.method === 'videoask' &&
      latestSession.status === 'completed' &&
      latestSession.outcome === 'fail')
  ) {
    // There is no next step to take
    return null
  }

  if (
    latestSession?.config.method === 'yoti' &&
    latestSession.status === 'completed' &&
    latestSession.outcome === 'fail' &&
    latestSession.yotiMethod === YotiMethod.AgeEstimation
  ) {
    return 'choice'
  }

  return 'videoask'
}
